let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("460A8")).then(() => parcelRequire('3W45k'));